module.exports = __webpack_public_path__ + "media/whats_your_status_series_successful_internship_search_tips/crm_internships_sidebar_01-075cfdce.jpg";